export const getVisiblePages = (
  currentPage: number,
  maxPages: number
): (number | 'dots')[] => {
  if (maxPages <= 7) {
    return Array.from({ length: maxPages }, (_, index) => index + 1);
  }

  if (currentPage <= 4) {
    return [1, 2, 3, 4, 5, 'dots', maxPages];
  }

  if (currentPage >= maxPages - 3) {
    return [1, 'dots', maxPages - 3, maxPages - 2, maxPages - 1, maxPages];
  }

  return [
    1,
    'dots',
    currentPage - 1,
    currentPage,
    currentPage + 1,
    'dots',
    maxPages,
  ];
};
